import styled from 'styled-components';

export const StickySection = styled.div`
  position: sticky !important;
  top: ${(props) => (props.showHeader == '-56px' ? '-1px' : '54px')};
  background: white;
  z-index: 2;
  @media (min-width: 720px) {
    top: ${(props) => (props.showHeader == '-56px' ? '51px' : '90px')};
  }
  transition: all 0.3s ease;
  display: grid;
`;
export const MaternityChipsSection = styled.nav`
  display: flex;
  overflow-x: scroll;
  scroll-behavior: smooth;
  justify-content: flex-start;
  &::-webkit-scrollbar {
    display: none;
  }
  text-transform: capitalize;
  padding: 10px;
  flex-wrap: ${(props) => (props.wrapHeight === 130 ? 'wrap' : 'unset')};
`;

export const MaternityChipsItem = styled.a`
  background-color: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
  font-size: clamp(14px, 2vw, 16px);
  flex-shrink: 0;
  border-radius: 18px;
  padding: 8px 10px;
  &.active {
    color: #ffffff;
    background-color: #63b0a8;
  }
  &.lowOpacity {
    background-color: #f2f2f2;
  }
  @media (min-width: 768px) {
    cursor: pointer;
  }
  width: max-content !important;
  margin: 6px;
  @media (min-width: 720px) {
    margin-right: 20px;
    cursor: pointer;
  }
`;
